<template>
  <div class="col-3 px-1 d-flex flex-column vh-content">
    <b-card
      small
      no-body
      bg-variant="primary"
      class="board-column shadow mb-0 bg-lighten-5"
    >
      <b-card-body
        class="d-flex flex-row justify-content-between align-items-center py-0 pl-1 pr-2"
      >
        <b-card-title class="h5 ml-2 my-3 text-primary text-darken-4 text-capitalize">
          {{column.name}}
        </b-card-title>
        <CheckPermission permission="ED067">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            v-if="column.canCreate && showActions"
            variant="primary"
            class="btn-icon"
            size="sm"
            @click="$emit('create-activity', column)"
            data-cy="create-activity"
          >
            <feather-icon icon="PlusIcon"/>
          </b-button>
        </CheckPermission>
      </b-card-body>
    </b-card>
    <slot />
  </div>
</template>
<script>
import CheckPermission from '@/febos/global/usuario/components/CheckPermission';

export default {
  components: {
    CheckPermission
  },
  props: {
    showActions: { type: Boolean, default: true },
    column: {
      name: { type: String, required: true },
      canCreate: { type: Boolean, default: false }
    }
  }
};

</script>
<style lang="scss" scoped>

.board-column {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

</style>
